import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
//import { withRouter } from 'react-router-dom';
//import { auth, db } from '../firebase'
//import { dispatch } from 'store';
import {watchAuth} from './index'
import Login from '../Components/App/Login'


const initializeApp = (settings) => (Component) => {
  class InitializeApp extends React.Component {
     
    async componentDidMount() {
      watchAuth()
    }
    
    render() {
        //const userIsAuth = watchUserAuth()
      const userIsAuth = this.props.authUser
      return  (
        
        userIsAuth
          ? <Component authUser={userIsAuth}/>
          : <Login />
  
      )
    }
  }

  const mapStateToProps = (state) => ({
    authUser: state.userState.profile !==null,
    userProfile: state.userState.profile,
  });

  return compose(

    connect(mapStateToProps),
  )(InitializeApp);
}

export default initializeApp;


// WEBPACK FOOTER //
// ./src/appInit/initializeApp.js